var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-modal"},[_c('div',{staticClass:"loading flex flex-col gap-6 items-center justify-center relative h-full px-4"},[_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div')])])])
}]

export { render, staticRenderFns }